import { Component } from '@verndale/core';
import { createFocusTrap } from 'focus-trap';
import { focusableElements } from '../helpers';
import { KEYS } from '../constants';
import Cookies from 'js-cookie';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $trigger: document._$$(`[data-trigger-modal=${this.el.id}]`),
      $closeButton: this.el._$('.modal__close-button'),
      $backdrop: this.el._$('.modal__backdrop'),
      $content: this.el._$('.modal__content')
    };

    this.incidentModal = this.el.classList.contains('incident-modal');
    this.dom.$loadingRing = document.createElement('div');
    this.dom.$loadingRing.classList.add('loading-ring');
    this.dom.$loadingRing.setAttribute('role', 'presentation');
    this.dom.$loadingRing.innerHTML =
      '<div></div><div></div><div></div><div></div>';

    this.focusableModalElements = this.el._$$(focusableElements);
    this.focusTrap = createFocusTrap(this.el);
    this.hasCookie = this.el.dataset.hasCookie;
    this.isRtf = this.el.dataset.isRtf;

    if (this.isRtf) {
      const iframes = this.dom.$content._$$('iframe');
      this.dom.$content.classList.add('rtf');

      if (iframes.length > 0) {
        iframes.forEach(iframe => {
          const wrapper = document.createElement('div');
          const inPar = iframe.parentNode.tagName.toLowerCase() === 'p';
          wrapper.classList.add('modal__video-container');
          inPar
            ? iframe.parentNode.parentNode.insertBefore(
              wrapper,
              iframe.parentNode
            )
            : iframe.parentNode.insertBefore(wrapper, iframe);
          wrapper.appendChild(iframe);
        });
      }
    }

    if (this.el.classList.contains('modal--auto-open')) {
      if (this.hasCookie) {
        this.shouldDisplay() ? this.openModal() : this.el.remove();
      } else {
        this.openModal();
      }
    }
  }

  addListeners() {
    this.el._on('keydown', this.handleKeydown.bind(this));
    this.dom.$backdrop?._on('click', this.handleBackdropClick.bind(this));
    this.dom.$closeButton?._on('click', this.closeModal.bind(this));
    this.dom.$trigger?._on('click', this.openModal.bind(this));
    this.el._on('openmodal', this.openModal.bind(this));
    this.el._on('closemodal', this.closeModal.bind(this));

    if (this.el.dataset?.detailPage === '') {
      const removeBtn = this.el._$('.remove-member-modal__btn');
      removeBtn?._on('click', this.handleRemoveBtnClick.bind(this));
    }
  }

  shouldDisplay() {
    this.modals = Cookies.get('ue_modals');

    if (this.modals) {
      this.modals = JSON.parse(this.modals);

      if (this.modals.includes(this.el.id)) {
        return false;
      }
    } else {
      this.modals = [];
    }

    return true;
  }

  handleRemoveBtnClick(e) {
    const url = this.el.dataset.removeUrl;
    const error = this.el._$('.update-contact-modal__error');
    const headers = {
      'content-type': 'application/json'
    };

    e.currentTarget.disabled = true;
    e.currentTarget.appendChild(this.dom.$loadingRing);
    fetch(url, {
      method: 'POST',
      headers
    })
      .then(r => r.json())
      .then(data => {
        if (data.Success) {
          window.location.href = data.RedirectUrl;
        } else {
          error.hidden = false;
          error.innerHTML = data.Message;
        }
      })
      .catch(console.error)
      .finally(() => {
        this.dom.$loadingRing.remove();
        e.currentTarget.disabled = false;
      });
  }

  handleKeydown({ keyCode }) {
    if (keyCode === KEYS.ESC && !this.el.dataset.disableModalEscape) {
      this.closeModal();
    }
  }

  handleBackdropClick(e) {
    if (
      e.target === this.dom.$backdrop &&
      !this.el.dataset.disableModalEscape
    ) {
      this.closeModal();
    }
  }

  openModal() {
    const timer = this.el.dataset.reset ? 300 : 0;

    setTimeout(() => {
      if (this.el.dataset.reset) {
        this.focusableModalElements = this.el._$$(focusableElements);
        this.focusTrap = createFocusTrap(this.el);
      }
      this.lastFocusedElement = document.activeElement;
      this.focusableModalElements?.forEach(element =>
        element.setAttribute('tabindex', '1')
      );
      this.el.setAttribute('aria-hidden', 'false');
      if (!this.incidentModal) {
        this.focusTrap.activate();
      }

      if (this.focusableModalElements?.length) {
        this.focusableModalElements[0].focus();
      }

      const event = new Event('modalopen');
      this.el.dispatchEvent(event);
    }, timer);
  }

  closeModal() {
    if (this.el._$('.update-contact-modal__error'))
      this.el._$('.update-contact-modal__error').innerHTML = '';
    this.focusTrap.deactivate({ returnFocus: false });
    this.el.setAttribute('aria-hidden', 'true');

    if (this.lastFocusedElement) this.lastFocusedElement.focus();
    const event = new Event('modalclose');
    this.el.dispatchEvent(event);

    if (this.hasCookie) {
      this.modals.push(this.el.id);
      Cookies.set('ue_modals', JSON.stringify(this.modals));
      this.el.remove();
    }
  }
}

export default Module;
